import React from 'react';
import {GroupFilter} from '../../../components/filter/Filters';
import {TabView} from '../../../components/tab/TabView';
import {useFilter} from '../../../controllers/useFilter';
import {
  ApprovedWFHRequestTable,
  ClosedTourRequestTable,
  PendingTourRequestTable,
  PendingWFHRequestTable,
  RejectedWFHRequestTable,
} from './TeamWFHRequestTables';

export const TeamWFHRequestTab = props => {
  let {route: {params} = {}, practiceHead, user} = props;
  let {filterValues, searchValue, onChangeFilter, applyFilter} = useFilter({});
  let {filter, params: filterParams = {}} = filterValues;
  let {organization, product, period, ...rest} = params;

  params = {
    ...filterValues,
    ...filterParams,
    ...rest,
    product,
    organization,
  };
  if (practiceHead) {
    filter = {
      ...filter,
      practice_head: user?.employee?._id,
    };
  }
  const tabs = {
    pending: {
      label: 'Open',
      view: (
        <PendingWFHRequestTable
          filterParams={filterParams}
          filter={filter}
          practiceHead={practiceHead}
          params={params}
          {...props}
        />
      ),
      eventSourceId: 'pendingwfhrequest',
      actions: [
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Employee',
              api: '/employeeSuggestions',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'employee',
              searchFields: ['name', 'official_email_id', 'employee_code'],
            },
          ]}
        />,
      ],
    },
    approved: {
      label: 'Closed',
      view: (
        <ApprovedWFHRequestTable
          filterParams={filterParams}
          filter={filter}
          practiceHead={practiceHead}
          params={params}
          {...props}
        />
      ),
      actions: [
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Employee',
              api: '/employeeSuggestions',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'employee',
              searchFields: ['name', 'official_email_id', 'employee_code'],
            },
          ]}
        />,
      ],
    },
    // rejected: {
    //   label: 'Rejected',
    //   view: (
    //     <RejectedWFHRequestTable
    //       filterParams={filterParams}
    //       filter={filter}
    //       params={params}
    //       {...props}
    //     />
    //   ),
    //   actions: [
    //     <GroupFilter
    //       filterValues={filterValues}
    //       applyFilter={applyFilter}
    //       filters={[
    //         {
    //           type: 'autoComplete',
    //           label: 'Employee',
    //           api: '/employeeSuggestions',
    //           placeholder: 'Select',
    //           suggestionField: 'name',
    //           valueField: 'name',
    //           field: 'employee',
    //           searchFields: ['name', 'official_email_id', 'employee_code'],
    //         },
    //       ]}
    //     />,
    //   ],
    // },
  };
  return <TabView tabs={tabs} params={params} {...props} />;
};

export const TeamTourRequestTab = props => {
  let {route: {params} = {}} = props;
  let {filterValues, searchValue, onChangeFilter, applyFilter} = useFilter({});
  let {filter, params: filterParams = {}} = filterValues;
  let {organization, product, period, ...rest} = params;

  params = {
    ...filterValues,
    ...filterParams,
    ...rest,
    product,
    organization,
  };
  const tabs = {
    pending: {
      label: 'Open',
      view: (
        <PendingTourRequestTable
          filterParams={filterParams}
          filter={filter}
          params={params}
          {...props}
        />
      ),
      eventSourceId: 'pendingwfhrequest',
      actions: [
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Employee',
              api: '/employeeSuggestions',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'employee',
              searchFields: ['name', 'official_email_id', 'employee_code'],
            },
          ]}
        />,
      ],
    },
    approved: {
      label: 'Closed',
      view: (
        <ClosedTourRequestTable
          filterParams={filterParams}
          filter={filter}
          params={params}
          {...props}
        />
      ),
      actions: [
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Employee',
              api: '/employeeSuggestions',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'employee',
              searchFields: ['name', 'official_email_id', 'employee_code'],
            },
          ]}
        />,
      ],
    },
    // rejected: {
    //   label: 'Rejected',
    //   view: (
    //     <RejectedWFHRequestTable
    //       filterParams={filterParams}
    //       filter={filter}
    //       params={params}
    //       {...props}
    //     />
    //   ),
    //   actions: [
    //     <GroupFilter
    //       filterValues={filterValues}
    //       applyFilter={applyFilter}
    //       filters={[
    //         {
    //           type: 'autoComplete',
    //           label: 'Employee',
    //           api: '/employeeSuggestions',
    //           placeholder: 'Select',
    //           suggestionField: 'name',
    //           valueField: 'name',
    //           field: 'employee',
    //           searchFields: ['name', 'official_email_id', 'employee_code'],
    //         },
    //       ]}
    //     />,
    //   ],
    // },
  };
  return <TabView tabs={tabs} params={params} {...props} />;
};
